export const GEO_CITY = 'GEO_CITY';
export const GEO_ASN = 'GEO_ASN';
export const SESSION = 'SESSION';
export const SESSION_PER_PAGE = 200;
export const MAX_ANCHORED_COUNT = 3;
export const CARDINALITY_ERROR = 'This viewer has high cardinality of Devices >= 201. Try reducing the query time range.';
